import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex);

const store = new Vuex.Store({
  state: {
    topId:"",
    showSyList: [],
    loginStatus: [],
    username: "",
    searchParams: {},
    topchoose: "",
    topchoose2: "",
    leftMap: [],
    statistics: [],
    result: [],
    resultgjss: [],
    notLogin: "",
    thirdLogin: false,
    getList261: "",
    getList2281: "",
    getList1283: "",
    getList1258: "",
    getList1306: "",
    getList2087: "",
    getList2143: "",
    getList2185: "",
    loading: false,
    isPhone: false,
    isAdmin: false,
    exportshow: [],
    searchshow: [],
    cheakshow: [],
    copyshow:[],
  },
  getters: {
    highlight: state => {
      if (state.searchParams["title"] != null && state.searchParams["title"] != "") {
        return state.searchParams["title"];
      }
    }
  },
  mutations: {
    topId(state, item) {
      state.topId = item;
    },
    list(state, item) {
      state.showSyList = item;
    },
    checkLogin(state, item) {
      state.loginStatus = item;
    },
    userInfo(state, item) {
      state.username = item;
    },
    searchParams(state, item) {
      state.searchParams = item;
    },
    topchoose(state, item) {
      state.topchoose = item;
    },
    topchoose2(state, item) {
      state.topchoose2 = item;
    },
    leftMap(state, item) {
      state.leftMap = item;
    },
    statistics(state, item) {
      state.statistics = item;
    },
    result(state, item) {
      state.result = item;
    },
    resultgjss(state, item) {
      state.resultgjss = item;
    },
    notLogin(state, item) {
      state.notLogin = item;
    },
    thirdLogin(state, item) {
      state.thirdLogin = item;
    },
    loading(state, item) {
      state.loading = item;
    },
    getList261(state, item) {
      state.getList261 = item;
    },
    getList2281(state, item) {
      state.getList2281 = item;
    },
    getList2192(state, item) {
      state.getList2192 = item;
    },
    getList1258(state, item) {
      state.getList1258 = item;
    },
    getList1283(state, item) {
      state.getList1283 = item;
    },
    getList1306(state, item) {
      state.getList1306 = item;
    },
    getList2087(state, item) {
      state.getList2087 = item;
    },
    getList2143(state, item) {
      state.getList2143 = item;
    },
    getList2185(state, item) {
      state.getList2185 = item;
    },
    isPhone(state, item) {
      state.isPhone = item;
    },
    isAdmin(state, item) {
      state.isAdmin = item;
    },
    exportshow(state, item) {
      state.exportshow = item;
    },
    searchshow(state, item){
      state.searchshow =item;
    },
    cheakshow(state, item){
      state.cheakshow =item;
    },
    copyshow(state, item){
      state.copyshow =item;
    }
  }
})

export default store



// WEBPACK FOOTER //
// ./src/vuex.js